import React from "react";
import { Button, Glyphicon } from "react-bootstrap";
import "../css/utils/LoaderButton.css";

export default ({
  isLoading,
  text,
  loadingText,
  className = "",
  disabled = false,
  ...props
}) =>
    <Button
      className={`LoaderButton ${className}`}
      disabled={disabled || isLoading}
      style = {{width:    props.width,
                height:   props.height,
                fontSize: 16,
                color:    "white",
                backgroundColor: props.btncolor,
              }}
      {...props}
    >
            {isLoading && <Glyphicon glyph="refresh" className="spinning" />}
            {!isLoading ? text : loadingText}            
      </Button>;



// WEBPACK FOOTER //
// ./src/components/LoaderButton.js